/* eslint-disable max-len, prettier/prettier */
/* global __DEV__ */

import queryString from 'query-string';
import transportTypes from './json/transportTypes.json';
import { PACKAGES_TYPES } from './payment';
import { EVENT_TYPES, INTERVALS, OBJECT_TYPES, AGGREGATION_FIELDS } from './stats';

const basePath = '/api';
export const TRANSPORTS_PATH = `${basePath}/transports`;
export const CLASSIFIERS_PATH = `${basePath}/classifiers`;
const SEO_URLS = `${basePath}/seo-urls`;
const API_EXPRESS = `/api-urls`;
const POLIS_PATH = `${basePath}/polis`;
const SHOW_IN_AB_PARAMS = `show_in_ab=1`;
// const FIN_UP = 'https://api.finup.lv/v1';
//
const DEFAULT_TYPE = transportTypes.find(item => item.slug === 'avto').id;

/**
 * The word '_posts' is used in paths instead of 'adverts' to be replaced later (in the proxy).
 * This is because requests containing that word are being cancelled by AdBlock.
 * */
export const originalAdverts = 'adverts';
export const safeAdverts = '_posts';

const API = {
  // LEASING_PARAM: {
  //   GET_TEMPERATURE: `${FIN_UP}/temperature/`,
  //   GET_VERIFICATION: `${FIN_UP}/verification/`,
  // },
  ADVERT: {
    ALL: (params = '') => `${basePath}/${safeAdverts}/${params}`,
    ITEM: id => `${basePath}/${safeAdverts}/${id}/`,
    SIMILAR: (id, similarities) => `${basePath}/${safeAdverts}/${id}/similar/?similarities=${similarities}`,
    LIST: `${basePath}/${safeAdverts}/`,
    MY: ({ ...query }) => `${basePath}/${safeAdverts}/my/?${queryString.stringify(query)}`,
    COUNT: `${basePath}/${safeAdverts}/_count/`,
    MAKES_COUNT: `${basePath}/makes/${safeAdverts}/_count/`,
    MODELS_COUNT: `${basePath}/models/${safeAdverts}/_count/`,
    photos: id => `${basePath}/${safeAdverts}/${id}/photos/`,
    photosNew: () => `${basePath}/upload/`,
    photosItem: photoId => `${basePath}/${safeAdverts}/photos/${photoId}/`,
    STATUS: advertsIds => `${basePath}/accounts/${safeAdverts}/?id=${advertsIds.join(',')}`,
    FAVORITES: `${basePath}/favorites/`,
    FAVORITES_ADVERTS: ({ transportId }) => `${basePath}/favorites-adverts/?${queryString.stringify({ transport: transportId })}`,
    PHONES: advertID => `${basePath}/${safeAdverts}/${advertID}/phones/`,
    PARAMS_BY_ID: {
      make: id => `${TRANSPORTS_PATH}/makes/${id}`,
      model: id => `${TRANSPORTS_PATH}/models/${id}`,
      engine: id => `${TRANSPORTS_PATH}/engines/?id=${id}`,
      body: id => `${TRANSPORTS_PATH}/categories/?id=${id}`,
    },
    PARAMS_BY_REG_NUMBER: regNumber => `${basePath}/vehreg/vehicles/current/${regNumber}/`,
    warranty: userId => `${basePath}/dealers/?user=${userId}`,
    APPROVE_PUB: (userId, key) => `${basePath}/_posts/${userId}/approve-pub/?key=${key}`,
    SEARCH_SUB: `${basePath}/${safeAdverts}/search-sub/`,
    SEARCH_SUB_BY_ID: id => `${basePath}/${safeAdverts}/search-sub/${id}/`,
    //
    LEASING: {
      GET_PARAMS: `${API_EXPRESS}/leasing/verification/`,
      ADD_BITRIX_LEAD: 'https://avtobazar.bitrix24.ua/rest/1/hb181kj300s9yv0n/crm.lead.add/',

      ADD_FINUP_LEAD:  `${API_EXPRESS}/leasing/application/`,
      ADD_AFINANCE_LEAD:  `${API_EXPRESS}/leasing/afinance/`,
      ADD_AUTOMONEY_LEAD:  `${API_EXPRESS}/leasing/automoney/`,
      GET_RATE:  `${API_EXPRESS}/leasing/rate/`,
      GET_TEMPERATURE:  `${API_EXPRESS}/leasing/temperature/`,
      

      REQUEST_ID: `${basePath}/fin_up/otp/`,
      SCORING: `${basePath}/fin_up/scoring/`,
    },
    //
    MICRO_CREDITS: {
      ADD: `${API_EXPRESS}/microcredit/`,
    }, 
    //
    CREDIT_MARKET: {
      ADD: `${API_EXPRESS}/creditmarket/`,
    },   
    //
    LEASING_ULF24: {
      ADD_LEAD: `${API_EXPRESS}/leasing/ulf24/addlead/`,
      CALCULATE: `${API_EXPRESS}/leasing/ulf24/calculate/`,
    },
    LEASING_ULF: {
      ADD_LEAD: `${API_EXPRESS}/leasing/ulf/addlead/`,
    },
    SUGGESTION: {
      ADD_SUGGESTION: `${API_EXPRESS}/suggestion/add/`,
    },

  },
  ARTICLES: (url) => `${SEO_URLS}/leasing/?url=${url}`,

  AUTHORIZE: `${basePath}/authorize/`,
  PROFILE: `${basePath}/users/profile/`,
  USER_PROFILE: `${basePath}/users/profile/`,
  REGISTER: `${basePath}/users/register/`,
  SEND_MAIL: `${basePath}/send_email/`,
  SUPPORT_SET_MAIL: `${API_EXPRESS}/support-mail/`,
  SEND_CREDIT_MAIL: `${API_EXPRESS}/credit-mail/`,
  LEASING: `${API_EXPRESS}/leasing/`,
  SET_VIN: `${basePath}/_posts/vin-check-claim/`,
  GET_PHONE:(params)=> `${basePath}/_posts/${params}/phones/`,
  USERS_AUTHORIZE: `${basePath}/users/authorize/`,
  USERS_AUTHORIZE_TOKEN: `${basePath}/users/authorize/token/`,
  USERS_RECOVERY: `${basePath}/users/recovery/`,
  USERS_VERIFY_RESEND: `${basePath}/users/verify/resend/`,
  USERS_VERIFY_GET: `${basePath}/users/verify/`,
  USERS_LOGISTICS: `${basePath}/stats/`,
  KATALOG_KOMPANIY_STO: `/katalog-kompaniy/sto/`,
  KATALOG_KOMPANIY: (params)=>`/katalog-kompaniy/${params}/`,
  USERS_USER_CHECK_CODE: `${basePath}/users/check/`,
  CHANGE_USER_PASSWORD: `${basePath}/users/profile/set-password/`,
  SOCIAL_LOGIN: {
    FB: `${basePath}/users/authorize/facebook/`,
  },
  CMM: {
    allSeries: () => `${TRANSPORTS_PATH}/categories`,
    allDrives: () => `${TRANSPORTS_PATH}/drives`,
    allGearboxes: () => `${TRANSPORTS_PATH}/gearboxes`,
    modelsByMake: (makeID, transportID) => `${TRANSPORTS_PATH}/models/?${queryString.stringify({ make: makeID, transport: transportID })}`,
    modelById:(modelID) => `${TRANSPORTS_PATH}/models/${modelID}/`,
    generationsByModel: modelID => `${TRANSPORTS_PATH}/generations/?model=${modelID}`,
    generationById: generationID => `${TRANSPORTS_PATH}/generations/${generationID}/`,
    seriesByGeneration: generationID => `${TRANSPORTS_PATH}/series/?generation=${generationID}`,
    seriesByModel: modelID => `${TRANSPORTS_PATH}/series/?model=${modelID}`,
    modificationsBySeries: seriesID => `${TRANSPORTS_PATH}/modifications/?series=${seriesID}`,
    equipmentsByModification: (modificationID, typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/equipments/?modification=${modificationID}&transport=${typeID}`,
    //
    averagePrice: params => `${CLASSIFIERS_PATH}/average-price/?${queryString.stringify(params)}`,
    //
    sparetypesBySection: sectionId => `${CLASSIFIERS_PATH}/sparepart-sections/?parent=${sectionId}`,
    sparetypesById: subsectionId => `${CLASSIFIERS_PATH}/sparepart-sections/?id=${subsectionId}`
  },
  DEALER: {
    MAKES_COUNT: id => `${basePath}/makes/_posts/_count/?dealer=${id}`,
  },
  DEALERS: {
    ALL: (params = '') => `${basePath}/dealers/${params}`,
    COUNT: `${basePath}/dealers/_count/`,
    ITEM: slug => `${basePath}/dealers/${slug}/`,
    MAKES_COUNT: `${basePath}/makes/dealers/_count/`,
    REQUEST_SERVICE: `${API_EXPRESS}/dealer-services/`,
  },
  FIRMS: {
    ALL: (params = '') => `${basePath}/firms/${params}`,
    ITEM: slug => `${basePath}/firms/${slug}/`,
    TYPE_WORK: () => `${basePath}/firms/services-for-filter/`,
    COUNT: `${basePath}/firms/_count/`,
    NEW_COUNT: params =>`${basePath}/firms/${params}`,
    TAGS_COUNT: `${basePath}/firms/tags/_count/`,
  },
  PHONES: {
    ADD: `${basePath}/users/phones/`,
    DELETE: id => `${basePath}/users/phones/${id}/`,
    RESEND_CODE: `${basePath}/users/phones/verify/resend/`,
    VERIFY_PHONE: `${basePath}/users/phones/verify/`,
  },
  VOCABULARY: {
    authormakes: (typeID = DEFAULT_TYPE, authorId) => `${basePath}/spareparts/author-makes/?author=${authorId}&transport=${typeID}`,
    authormodels: (makeID, authorId) => `${basePath}/spareparts/author-models/?author=${authorId}&make=${makeID}`,
    subtypes: typeID => `${TRANSPORTS_PATH}/types/?parent=${typeID}`,
    makes: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/makes/?transport=${typeID}`,
    drives: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/drives/?transport=${typeID}`,
    options: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/options-tree/?transport=${typeID}`,
    engineFeatures: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/engine-features/?transport=${typeID}`,
    categories: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/categories/?transport=${typeID}`,
    types: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/types/?parent=${typeID}`,
    engines: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/engines/?transport=${typeID}`,
    gearboxes: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/gearboxes/?transport=${typeID}`,
    seaworthinessClasses: () => `${API_EXPRESS}/transports/seaworthiness-classes/`,
    locations: () => `${CLASSIFIERS_PATH}/locations/all/?parent_id=1911`,
    locationsAll: id => `${CLASSIFIERS_PATH}/locations/all/${id && `?parent_id=${id}`}`,
    location: id => `${CLASSIFIERS_PATH}/locations/${id}/`,
    countries: `${CLASSIFIERS_PATH}/locations/`,
    colors: () => `${CLASSIFIERS_PATH}/colors/`,
    colorFeatures: () => `${CLASSIFIERS_PATH}/color-features/`,
    currencies: `${CLASSIFIERS_PATH}/currencies/`,
    services: () => `${basePath}/accounts/services/`,
    rubrics: (typeID = DEFAULT_TYPE, parentID = null) =>
      `${CLASSIFIERS_PATH}/sparepart-sections/?transport=${typeID}${parentID ? `&parent=${parentID}` : ''}`,
    engineOrders: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/engine-orders/?transport=${typeID}`,
    ecotypes: () => `${TRANSPORTS_PATH}/ecotypes/`,
    tacts: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/tacts/?transport=${typeID}`,
    unloadings: (typeID = DEFAULT_TYPE) => `${TRANSPORTS_PATH}/unloadings/?transport=${typeID}`,
    suspensions: typeID => `${TRANSPORTS_PATH}/suspensions/?transport=${typeID}`,
    brakes: typeID => `${TRANSPORTS_PATH}/brakes/?transport=${typeID}`,
    cabins: typeID => `${TRANSPORTS_PATH}/cabins/?transport=${typeID}`,
    cabinSuspensions: typeID => `${TRANSPORTS_PATH}/cabin-suspensions/?transport=${typeID}`,
    chassisSuspensions: typeID => `${TRANSPORTS_PATH}/chassis-suspensions/?transport=${typeID}`,
  },
  SEO: {
    SEARCH_URLS: (url, query = {}) => `${SEO_URLS}/?${queryString.stringify({ url, ...query })}`,
    SEARCH_TRENDS: (query = {}) => `${SEO_URLS}/trends/?${queryString.stringify(query)}`,
    VIDEO_URLS: (url, query = {}) => `${SEO_URLS}/?${queryString.stringify({url, ...query })}`,
    SEARCH_TEXT: ( query = {}) => `${API_EXPRESS}/seo-text?${queryString.stringify(query)}`,
    SEARCH_MODEL: ( query = {}) => `${basePath}/transports/models/${query}/`,
    SEARCH_GENERATIONS: ( query = {}) => `${basePath}/transports/generations/${query}/`,
  },
  ACCOUNTS: {
    BALANCE: `${basePath}/accounts/info/`,
    ORDERS: userId => `${basePath}/accounts/user/${userId}/orders/`,
    FREE_SLOTS_COUNT: transportID => `${basePath}/accounts/free-slots-count/?transport=${transportID}`,
    FREE_SLOTS_COUNT_SPAREPARTS: `${basePath}/accounts/spareparts-slots-count/`,
  },
  PAYMENT: {
    // PORTMONE_GATEWAY: 'https://www.portmone.com.ua/gateway/',
    FONDY_GATEWAY: 'https://api.fondy.eu/api/checkout/redirect/',
    FONDY_ORDER_DATA: `${basePath}/accounts/order-fondy-data/`,
    FONDY_ORDER_CHECKOUT: `${basePath}/accounts/order-fondy-checkout/`,
    MONO_ORDER_DATA: `${basePath}/accounts/order-mono-data/`,
    MONO_ORDER_CHECKOUT: `${basePath}/accounts/order-mono-checkout/`,
    // LIQPAY_GATEWAY: 'https://www.liqpay.ua/api/3/checkout/',
    // LIQPAY_ORDER_DATA: `${basePath}/accounts/order-liqpay-data/`,
    ORDER_STATUS: '/accounts/order-status/',
    packages: (kind = PACKAGES_TYPES.C2C) => `${basePath}/accounts/tariff-plans/?kind=${kind}`,
    orders: () => `${basePath}/accounts/orders/`,
  },
  LOGOS: slug => `${basePath}/logos/${slug}/`,
  SPARE_PARTS: {
    ALL: params => `${basePath}/spareparts/${params || ''}`,
    COUNT:`${basePath}/spareparts/_count/`,
    ITEM: id => `${basePath}/spareparts/${id}/`,
    ITEM_PHOTOS: id => `${basePath}/spareparts/${id}/photos/`,
    PHOTOS_ITEM: photoId => `${basePath}/spareparts/photos/${photoId}/`,
    PHONES: id => `${basePath}/spareparts/${id}/phones/`,
    MY: params => `${basePath}/spareparts/my/${params || ''}`,
    RUBRIC_COUNT: `${basePath}/spareparts/rubrics/_count/`,
    MAKES_COUNT: `${basePath}/spareparts/makes/_count/`,
  },
  STATS: {
    BASE: `${basePath}/stats/`,
    AGGS: (
      identifiers = [],
      dateFrom = undefined,
      objects = [OBJECT_TYPES.ADVERT],
      field = AGGREGATION_FIELDS.OBJECT,
      interval = INTERVALS.DAY,
      events = [EVENT_TYPES.VIEW, EVENT_TYPES.PHONE_CLICK, EVENT_TYPES.REDIRECT],
    ) => `${basePath}/stats/aggs/${field}/?${queryString.stringify({
      id: identifiers.join(','),
      events: events.join(','),
      interval,
      objects,
      date_from: dateFrom,
    }, { encode: false })}`,
    COUNT: (ids, events = [EVENT_TYPES.VIEW], objects = [OBJECT_TYPES.ADVERT]) => `${basePath}/stats/_count/?${queryString.stringify({
      object: ids.join(','),
      events: events.join(','),
      objects: objects.join(','),
    }, { encode: false })}`,
  },
  JOURNAL: {
    ITEM: slug => `${basePath}/posts/?slug=${slug}`,
    LIST: ({
             page,
             tag,
             perPage,
             agency,
             mainPage,
             rubric = ['news', 'promo', 'test-drive'].join(','),
             make,
             model,
             generation,
             showInAdvert,
             showInVideo,
             ordering,
             topic,
             language,
           }) => `${basePath}/posts/?${SHOW_IN_AB_PARAMS}&${queryString.stringify({
      tag_slug: tag,
      rubric,
      per_page: perPage,
      main_page: mainPage,
      page,
      agency,
      make,
      model,
      generation,
      topic,
      show_in_advert: showInAdvert,
      show_in_video: showInVideo,
      ordering,
      language,
    }, { encode: false })}`,
    TEST_DRIVES: ({ make, model, year, generation, page, language }) => `${basePath}/posts/?${SHOW_IN_AB_PARAMS}&${queryString.stringify({
      rubric: 'test-drive',
      make,
      model,
      year,
      generation,
      page,
      language,
    })}`,
    RUBRICS: () => `${basePath}/posts/rubrics/`,
    TAGS: data => `${basePath}/posts/tags/_count/?${queryString.stringify(data)}&${SHOW_IN_AB_PARAMS}`,
    SET_STATS: () => `${basePath}/stats/`,
    VIDEO_TOPICS: language => `${basePath}/posts/topics/?${queryString.stringify(language)}`,
  },
  CONTACT: `${basePath}/contact/`,
  RATINGS: {
    competitors: ({ active, packages }) => `${basePath}/ratings/competitors/?${queryString.stringify({
      active,
      packages,
    }, { encode: false })}`,
  },
  NEW_CARS: `${basePath}/vehicles/newcars/`,
  CAR_DRIVE: {
    LIST: params => `${basePath}/firms/?${queryString.stringify(params)}`,
    SEND_FORM: `${basePath}/firms/car-drive-claim/`
  },
  CALCULATOR: params =>`${API_EXPRESS}/calculate-customs-clearance?${queryString.stringify(params)}`,
  POLIS: {
    OSAGO_FILTERS: lang => `${POLIS_PATH}/osago/filters/?langSign=${lang}`,
    REGIONS: (name, lang) => `${POLIS_PATH}/cities/?name=${name}&langSign=${lang}`,
    OFFERS: `${POLIS_PATH}/osago/offers/`,
    ORDERS_CREATE: () => `${POLIS_PATH}/osago/orders/`,
    ORDERS_FILL: orderHash => `${POLIS_PATH}/osago/orders/fill/${orderHash}/`,
    MY_ORDERS: lang => `${POLIS_PATH}/osago/orders/my/?langSign=${lang}`,
    MAKES: () => `${POLIS_PATH}/makes/?name=`,
    MODELS: (makeId) => `${POLIS_PATH}/models/?mark_id=${makeId}&name=`,
    CONFIRM_ORDER: hash => `${POLIS_PATH}/osago/orders/confirm/${hash}/`,
  },
  GET_ALL_DIALOGS: `${basePath}/users/dialogs/`,
  GET_DIALOG_MESSAGES: dialogId => `${basePath}/users/dialogs/${dialogId}/`,
  SEND_MESSAGES: advertId => `${basePath}/_posts/${advertId}/send-message/`,
  SEND_MESSAGES_REPLY: dialogId => `${basePath}/users/dialogs/${dialogId}/reply/`
};

export default API;



// WEBPACK FOOTER //
// ./src/shared/constants/api.js